module.exports = __webpack_public_path__ + "img/electronic_reserved.552075fa.svg";